import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'loyaltic-digital-win',
    templateUrl: './digital-win.component.html',
    styleUrls: ['./digital-win.component.scss'],
    standalone: false
})
export class DigitalWinComponent implements OnInit, AfterViewInit {

  @ViewChild('emailDigitalWinPopup', { static: false }) emailDigitalWinPopupRef: any;
  @ViewChild('phoneDigitalWinPopup', { static: false }) phoneDigitalWinPopupRef: any
  @ViewChild('captureSuccessWithReceipt', { static: false }) captureSuccessWithReceiptRef: any;

  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  winDetails: any;
  userId: any;
  clicked = false;
  showPhone = false;
  showSurvey = true;
  isPhoneParticipation = false;
  callCaptureWinApi = true;

  captureAddress = {
    Name: '',
    Email: '',
    Phone: '',
    Address: '',
    PostalCode: '',
    City: ''
  };

  constructor( private modalService: BsModalService,
    private dataService:DataServiceService,
     public translate: TranslateService,
     private router: Router,
     private authService: AuthService,
     public coreService: CoreService,
     private toast: ToastrService
     ) {
      this.winDetails = this.dataService.getWinDetails()
      this.userId = this.authService.getUserId();
  }

  ngOnInit() {
    let sub = this.dataService.callGetPlay()
    if(this.authService.IsLoggedIn()){
      // this.captureAddress.Phone = (parseInt(localStorage.getItem('user'))/111).toString();
      this.coreService.getEmailAndPhone(this.userId).then((response:any) =>{
        console.log('userr', response);
        var loginType = localStorage.getItem('LoginType');
        console.log("======loginType", loginType)
        if(loginType=="Email")
        {
          console.log("===========in if email")
          this.captureAddress.Email = response.result.userName;
          this.isPhoneParticipation = false;
        }
        else{
          console.log("===========in else phone")
          this.captureAddress.Phone = '';
          this.isPhoneParticipation = true;
        }
      })
    }
    if(localStorage.getItem('surveyTaken') == 'true') {
      this.showSurvey = false;
    }
  }


  ngAfterViewInit() {
    if(localStorage.getItem('LoginType') === 'Email'){
    this.modalRef = this.modalService.show(this.emailDigitalWinPopupRef, this.popupConfig);
    } else if (localStorage.getItem('LoginType') === 'Phone') {
      this.modalRef = this.modalService.show(this.phoneDigitalWinPopupRef, this.popupConfig);
    }
  }

  onSubmitWinWithPhone(f) {
    this.coreService.Phonenumberexists(this.captureAddress.Phone).then((response:any)=> {
      this.onSubmitWinWithReceipt(f);
    }, (errorResponse: any)=> {
      if (errorResponse.status == 400) {
        this.callCaptureWinApi = false;
        const errorMessage = 'error-phonenumber-exist';
        this.toast.error(errorMessage);
      } else {
        const errorMessage = this.translate.instant(errorResponse.error.messageKey);
        this.toast.error(errorMessage);
      }
    })
  }


  onSubmitWinWithReceipt(f) {
    this.clicked = true;
    const formData = new FormData();
    let body: any;

    formData.append('UserId', this.userId);
    formData.append('UserRewardRowKey', this.winDetails ? this.winDetails.userRewardRK : undefined);

    if(localStorage.getItem('LoginType') === 'Email'){
      formData.append('LoginType', 'Email')
      formData.append('Value', this.captureAddress.Email);

    }
    if(localStorage.getItem('LoginType') === 'Phone'){
      formData.append('LoginType', 'Phone')
      formData.append('Value', this.captureAddress.Phone);
    }

    this.coreService.captureDigitalWin(formData).then(response => {

      // this.gaService.emitEvent('reward_redeemed', 'reward_redeemed');
      this.modalRef.hide();
      this.resetWinDetails();
      this.modalRef = this.modalService.show(this.captureSuccessWithReceiptRef, this.popupConfig);
    });

  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // playAgain() {
  //   this.getPlay();
  // }

  redirectToHome() {
    this.modalRef.hide();
    this.router.navigate([''])
  }

  resetWinDetails() {
    this.captureAddress = {
      Name: '',
      Email: '',
      Phone: '',
      Address: '',
      PostalCode: '',
      City: ''
    };
  }

  surveyTaken() {
    localStorage.setItem('surveyTaken','true')
  }

}
